__webpack_require__.p = "/frontendmentor-news-homepage/";